import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Buscabserviceinindapur() {



  const cardData =
  {
    keyword: 'Best Cab Service in Indapur',
    heading: 'Sanavi Travels: Best Cab Service in Indapur',
    headingDescription: 'Sanavi Travels offers the best cab service in Indapur, providing safe, comfortable, and reliable transportation for local travel, sightseeing, outstation trips, and corporate journeys. Our fleet of well-maintained hatchbacks, sedans, SUVs, and premium cabs ensures smooth rides, air-conditioning, and ample luggage space for a hassle-free experience. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient doorstep pickup and drop across Indapur, Pune, and nearby areas, making it ideal for family trips, business travel, group tours, and religious visits. Choose Sanavi Travels for trusted cab services in Indapur, delivering comfort, safety, and a seamless travel experience every time.',

    top: 'Top Places to Visit in Indapur with Sanavi Travels',


"topPlaces": [
  {
    "title": "Indapur Town",
    "description": "Indapur is a historic town in Pune district, Maharashtra, known for its rich cultural heritage and strategic location on the banks of the Bhima River. It has a legacy dating back to the Maratha and Mughal periods and serves as a gateway to the rural landscapes and forts of eastern Pune. The town offers visitors a mix of historical sites, local markets, and serene riverside scenery."
  },
  {
    "title": "Indreshwar Mandir",
    "description": "Indreshwar Mandir is a prominent temple in Indapur dedicated to Lord Shiva. It is a focal point for devotees, especially during festivals like Mahashivratri. The temple’s traditional architecture and spiritual ambiance attract pilgrims and tourists seeking peace and religious experience."
  },
  {
    "title": "Bhima Riverfront",
    "description": "The banks of the Bhima River in Indapur provide tranquil spots for relaxation, morning walks, and picnics. During the monsoon, the river swells and the surrounding greenery becomes lush, making it ideal for photography and nature walks."
  },
  {
    "title": "Historic Forts Nearby",
    "description": "Indapur is surrounded by several historical forts from the Maratha era, such as the Chavand and Bhorgiri forts. These forts offer trekking opportunities, panoramic views of the landscape, and insights into regional history and military architecture."
  },
  {
    "title": "Local Markets and Handicrafts",
    "description": "Indapur’s markets reflect the region’s rural lifestyle, offering fresh agricultural produce, traditional handicrafts, and local delicacies. Visitors can explore these markets to understand local culture and take home souvenirs."
  },
  {
    "title": "Chikhali Fort (Nearby)",
    "description": "Chikhali Fort is a historic fort near Indapur, showcasing Maratha architectural style. It attracts history enthusiasts and trekkers who want to explore ancient battlements and enjoy panoramic views of the surrounding plains."
  },
  {
    "title": "Agricultural Fields and Rural Tourism",
    "description": "The region around Indapur is fertile and primarily agricultural, with farms producing sugarcane, vegetables, and grains. Visitors can witness traditional farming practices and experience rural life firsthand, making it ideal for agro-tourism experiences."
  },
  {
    "title": "Temples of Indapur Taluka",
    "description": "Indapur Taluka is home to numerous small temples and shrines dedicated to local deities, reflecting the spiritual and cultural fabric of the region. These sites host festivals and rituals throughout the year."
  },
  {
    "title": "Nature Trails and Hill Views",
    "description": "The surrounding hills and natural trails provide trekking and walking opportunities. Travelers can enjoy scenic vistas of the Bhima river valley, forests, and rural landscapes, especially during sunrise and sunset."
  },
  {
    "title": "Local Cuisine and Eateries",
    "description": "Indapur offers traditional Maharashtrian cuisine with local eateries serving dishes like bhakri, vadi, and regional sweets. Sampling the local food provides an authentic cultural and culinary experience."
  }
]
,



"services": [
{
"name": "Best Cab Service in Indapur",
"description": "Best Cab Service in Indapur provides reliable, safe, and comfortable taxi services for local travel, sightseeing, airport transfers, and outstation trips. With well-maintained vehicles, professional drivers, and timely pickups, it ensures a smooth and hassle-free journey. Perfect for families, tourists, corporate clients, and solo travelers, this service focuses on convenience, punctuality, and delivering a premium travel experience across Indapur and nearby regions."
},
{
"name": "Taxi Service Indapur",
"description": "Taxi Service Indapur offers efficient and professional cab solutions for city commuting, short trips, and planned excursions. With courteous drivers, transparent pricing, and flexible booking options, it is a trusted choice for residents, tourists, and business travelers seeking dependable transportation within Indapur and surrounding areas."
},
{
"name": "AC Cab Indapur",
"description": "AC Cab Indapur provides a comfortable and refreshing travel experience with fully air-conditioned vehicles. Ideal for long-distance trips, family outings, corporate travel, and sightseeing tours, these cabs ensure a smooth ride, relaxing interiors, and a premium travel experience for all passengers in Indapur."
},
{
"name": "Local Cab Indapur",
"description": "Local Cab Indapur offers quick, convenient, and affordable taxi services for city commuting, shopping trips, and local sightseeing. With professional drivers, punctual pickups, and well-maintained vehicles, it ensures safe and hassle-free short-distance travel for residents and visitors in Indapur."
},
{
"name": "Outstation Cab Indapur",
"description": "Outstation Cab Indapur specializes in long-distance travel services to nearby cities, tourist destinations, and hill stations. Comfortable vehicles, experienced drivers, and flexible itineraries provide safe, convenient, and enjoyable journeys for families, groups, and solo travelers exploring destinations beyond Indapur."
},
{
"name": "Affordable Cab Indapur",
"description": "Affordable Cab Indapur delivers budget-friendly taxi services without compromising on comfort or safety. Ideal for daily commuters, families, and group travelers, it combines economical pricing with well-maintained vehicles and professional drivers, making it a reliable choice for cost-conscious passengers traveling in and around Indapur."
},
{
"name": "Chauffeur Driven Cab Indapur",
"description": "Chauffeur Driven Cab Indapur provides professional drivers who handle navigation, traffic, and schedules efficiently, allowing passengers to relax throughout the journey. Perfect for VIP travel, corporate trips, family outings, and tourist excursions, it ensures a stress-free, smooth, and enjoyable travel experience."
},
{
"name": "Top Cab Service Indapur",
"description": "Top Cab Service Indapur is recognized for excellent customer service, clean vehicles, and professional drivers. Offering airport transfers, city travel, sightseeing, and outstation trips, it guarantees safe, reliable, and comfortable cab services for individuals, families, and corporate clients in and around Indapur."
},
{
"name": "Tourist Cab Indapur",
"description": "Tourist Cab Indapur caters to travelers exploring Indapur and nearby attractions. With flexible itineraries, knowledgeable drivers, and comfortable vehicles, it provides a memorable sightseeing experience, allowing tourists to enjoy cultural, historical, and scenic sites without worrying about logistics or navigation."
},
{
"name": "Airport Cab Indapur",
"description": "Airport Cab Indapur offers timely and convenient taxi services for airport pickups and drop-offs. Professional drivers, well-maintained vehicles, and real-time scheduling ensure passengers reach the airport on time and travel comfortably, making it a reliable choice for both domestic and international travelers."
},
{
"name": "Corporate Cab Indapur",
"description": "Corporate Cab Indapur provides professional taxi services for executives, office travel, meetings, and corporate events. With punctual pickups, experienced drivers, and clean vehicles, it ensures efficient, reliable, and stress-free transportation for business purposes in Indapur and nearby areas."
},
{
"name": "Online Cab Booking Indapur",
"description": "Online Cab Booking Indapur allows travelers to reserve cabs quickly and conveniently with instant confirmation. Multiple vehicle options, transparent pricing, and flexible scheduling make trip planning easy, hassle-free, and convenient for tourists, corporate clients, and local commuters alike."
},
{
"name": "Family Cab Indapur",
"description": "Family Cab Indapur provides spacious, safe, and comfortable vehicles suitable for family travel. Designed to accommodate all age groups, it ensures a smooth and enjoyable journey for family outings, vacations, and day trips within Indapur and surrounding areas."
},
{
"name": "24x7 Taxi Indapur",
"description": "24x7 Taxi Indapur offers round-the-clock taxi services for emergency travel, late-night pickups, airport transfers, and unplanned trips. With reliable drivers, well-maintained vehicles, and instant availability, it ensures passengers can travel safely and comfortably at any hour of the day or night."
},
{
"name": "Indapur Travel Taxi",
"description": "Indapur Travel Taxi provides complete taxi solutions for local commuting, tourist travel, and outstation trips. Combining comfort, safety, affordability, and professional service, it caters to residents, tourists, families, and corporate travelers seeking dependable and convenient transportation in Indapur and nearby areas."
}
],
"tableData": [
["Best Cab Service in Indapur", "Taxi Service Indapur"],
["AC Cab Indapur", "Local Cab Indapur"],
["Outstation Cab Indapur", "Affordable Cab Indapur"],
["Chauffeur Driven Cab Indapur", "Top Cab Service Indapur"],
["Tourist Cab Indapur", "Airport Cab Indapur"],
["Corporate Cab Indapur", "Online Cab Booking Indapur"],
["Family Cab Indapur", "24x7 Taxi Indapur"],
["Indapur Travel Taxi", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Best Cab Service in Indapur with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers the best and most reliable cab services in Indapur, perfect for local travel, airport transfers, sightseeing, and outstation journeys."
  },
  {
    "WhyChooseheading": "Clean and Well‑Maintained Cabs",
    "WhyChoosedescription": "Our cabs are regularly serviced, air‑conditioned, and kept clean to ensure a smooth and comfortable ride throughout Indapur."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Indapur routes and nearby areas, ensuring safe, timely, and pleasant travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for all cab services in Indapur, including fuel and toll charges, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with cab bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Wide Range of Ride Options",
    "WhyChoosedescription": "Choose from local rides, hourly hires, airport transfers, and outstation cab services based on your travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels the best cab choice in Indapur."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services in Indapur?',
    answer: 'Yes, Sanavi Travels offers dependable and comfortable cab services in Indapur for local and outstation travel.'
  },
  {
    question: 'How can I book a cab in Indapur?',
    answer: 'You can easily book a cab through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cab services are available in Indapur?',
    answer: 'Sanavi Travels offers local rides, airport transfers, hourly hires, and outstation cab services in Indapur.'
  },
  {
    question: 'Are the drivers experienced with routes in Indapur?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Indapur and nearby routes.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Indapur.'
  },
  {
    question: 'Is the cab service in Indapur available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock cab services in Indapur to suit your travel schedule.'
  },
  {
    question: 'Are the cabs sanitized before every trip?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for cab services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for cab bookings.'
  },
  {
    question: 'Is customer support available during the ride?',
    answer: 'Yes, our 24x7 customer support team is available throughout your cab service in Indapur.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Patil',
    feedback: 'Best cab service in Indapur! Sanavi Travels provided a clean car, courteous driver, and punctual service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha More',
    feedback: 'Excellent cab experience in Indapur — comfortable ride and very professional service. Highly recommended!',
    rating: 5
  }
];

















































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Best Cab Service in Indapur - Sanavi Travels",
  "description": "Sanavi Travels provides the best cab service in Indapur with AC local and outstation cabs, airport transfers, corporate travel, family trips, and 24x7 chauffeur-driven taxi services at affordable prices.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "41"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Best Cab Service in Indapur | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels offers the best cab service in Indapur with AC local and outstation cabs, airport transfers, corporate travel, family trips, and 24x7 chauffeur-driven taxi services at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/138.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Buscabserviceinindapur;